import React from 'react';
import Proptypes from 'prop-types';

import {
  StyledButton,
  StyledButtonPrimary,
  StyledButtonSecondary,
  StyledButtonBorderless,
  StyledButtonTransparent
} from './Styles';

import ControlledButton from './ControlledButton';

const propTypes = {
  testId: Proptypes.string,
  children: Proptypes.node,
  onClick: Proptypes.func,
  className: Proptypes.string,
  disabled: Proptypes.bool
};

const defaultProps = {
  testId: undefined,
  children: undefined,
  onClick: undefined,
  className: undefined,
  disabled: false
};

const Button = ({ id, testId, children, onClick, className, disabled }) => (
  <StyledButton
    data-testid={testId}
    onClick={onClick}
    className={className}
    id={id}
    disabled={disabled}
  >
    {children}
  </StyledButton>
);

Button.Primary = StyledButtonPrimary;
Button.Secondary = StyledButtonSecondary;
Button.Borderless = StyledButtonBorderless;
Button.Transparent = StyledButtonTransparent;
Button.Controlled = ControlledButton;

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
